import _ from 'underscore';
import {
  useDebugValue, useEffect, useRef,
} from 'react';
import type { DependencyList, EffectCallback } from 'react';

export function usePrevious<TValue>(value?: TValue) {
  const ref = useRef<TValue>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export function useDeepMemo<TValue>(value?: TValue) {
  const ref = useRef<TValue>();
  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}

export function useDeepEqualEffect(fn: EffectCallback, deps: DependencyList) {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);
  useEffect(() => {
    const isSame = prevDeps.current.every((value, index) => _.isEqual(value, deps[index]));
    if (isFirst.current || !isSame) {
      fn();
    }
    isFirst.current = false;
    prevDeps.current = deps;
  }, [deps, fn]);
  useDebugValue('useDeepEqualEffect');
}
